// extracted by mini-css-extract-plugin
var _1 = "OfficeModalClose__close--C4RvF";
var _2 = "OfficeModalClose__closeFallback--kV77D OfficeModalClose__close--C4RvF";
var _3 = "OfficeModalClose__closeHoverIcon--tIake OfficeModalClose__closeIcon--N8Xe_";
var _4 = "OfficeModalClose__closeIcon--N8Xe_";
var _5 = "OfficeModalClose__gray--SqUfz OfficeModalClose__closeIcon--N8Xe_";
var _6 = "OfficeModalClose__grayHover--U14kn OfficeModalClose__closeHoverIcon--tIake OfficeModalClose__closeIcon--N8Xe_";
var _7 = "OfficeModalClose__main--r4i48";
var _8 = "OfficeModalClose__white--r_vc8 OfficeModalClose__closeIcon--N8Xe_";
var _9 = "OfficeModalClose__whiteHover--fu3AO OfficeModalClose__closeHoverIcon--tIake OfficeModalClose__closeIcon--N8Xe_";
export { _1 as "close", _2 as "closeFallback", _3 as "closeHoverIcon", _4 as "closeIcon", _5 as "gray", _6 as "grayHover", _7 as "main", _8 as "white", _9 as "whiteHover" }
